import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
  timeout: 60000,
});

export const httpGetWebsite = ({ website_id }) => {
  const url = `/cmw/website/${website_id}/public_info/`;

  return http.get(url);
};

export const httpGetListings = ({ website_id, page, search, filters }) => {
  let url = `/listings/public/?website_id=${website_id}&page=${page}`;

  if (search) {
    url += `&search=${search}`;
  }

  if (filters) {
    Object.keys(filters).forEach((item) => {
      if (filters[item]) {
        url += `&${item}=${filters[item]}`;
      }
    });
  }

  return http.get(url);
};

export const httpGetListing = ({ website_id, listing_id }) => {
  const url = `/listings/public/${listing_id}/?website_id=${website_id}`;

  return http.get(url);
};

export const httpApplyForProperty = ({ website_id, listing_id, params }) => {
  const url = `/listings/public/${listing_id}/apply_for_property/?website_id=${website_id}`;

  return http.post(url, params);
};

export const httpSendEmail = ({ website_id, listing_id, params }) => {
  const url = `/listings/public/${listing_id}/send_email/?website_id=${website_id}`;

  return http.post(url, params);
};

export const httpGetAmenities = ({ association_id }) => {
  const url = `/amenities/?association_id=${association_id}`;

  return http.get(url);
};

export const httpGetCalendarEvents = ({
  account_id,
  start_date,
  end_date,
}) => {
  return http.get(
    `/calendars/public/?account_id=${account_id}&page=1&page_size=50&start_date=${start_date}&end_date=${end_date}`);
};

export default http;
